module.exports = __webpack_public_path__ + "static/media/login-bg-image.37569937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg-image.jpg
// module id = 774
// module chunks = 0